import { Link, useNavigate } from "react-router-dom";
import { useCartStore } from "../store";
import { getProductById } from "../data/products";

export function Cart() {
	const lines = useCartStore((s) => s.lines);
	const updateQuantity = useCartStore((s) => s.updateQuantity);
	const removeLine = useCartStore((s) => s.removeLine);
	const subtotal = useCartStore((s) => s.subtotal());
	const navigate = useNavigate();

	if (lines.length === 0) {
		return (
			<section className="max-w-xl mx-auto text-center py-16">
				<h1 className="text-3xl font-bold text-slate-900">
					Your cart is empty
				</h1>
				<p className="mt-2 text-slate-600">
					Looks like you haven't added anything yet.
				</p>
				<Link
					to="/products"
					data-testid="cart-empty-browse"
					className="btn-primary mt-6 inline-block"
				>
					Browse products
				</Link>
			</section>
		);
	}

	return (
		<section>
			<h1 className="text-3xl font-bold text-slate-900">Cart</h1>
			<ul className="mt-6 flex flex-col divide-y divide-slate-200 border border-slate-200 rounded-lg bg-white">
				{lines.map((line) => {
					const product = getProductById(line.productId);
					if (!product) return null;
					const lineSubtotal = product.price * line.quantity;
					return (
						<li
							key={line.productId}
							className="flex items-center gap-4 p-4"
						>
							<div
								className="h-14 w-14 rounded flex-shrink-0"
								style={{ backgroundColor: product.imageColor }}
								aria-hidden="true"
							/>
							<div className="flex-1 min-w-0">
								<p className="font-medium text-slate-900 truncate">
									{product.name}
								</p>
								<p className="text-sm text-slate-600">
									${product.price} each
								</p>
							</div>
							<input
								type="number"
								min={1}
								value={line.quantity}
								onChange={(event) =>
									updateQuantity(
										line.productId,
										Math.max(1, Number(event.target.value) || 1)
									)
								}
								data-testid={`cart-qty-${line.productId}`}
								className="w-20 rounded-md border border-slate-300 px-3 py-2"
							/>
							<span className="w-20 text-right font-medium text-slate-900">
								${lineSubtotal}
							</span>
							<button
								type="button"
								onClick={() => removeLine(line.productId)}
								data-testid={`cart-remove-${line.productId}`}
								className="btn-secondary text-sm"
							>
								Remove
							</button>
						</li>
					);
				})}
			</ul>
			<div className="mt-6 flex items-center justify-between">
				<span className="text-slate-700">Subtotal</span>
				<span
					data-testid="cart-subtotal"
					className="text-xl font-semibold text-slate-900"
				>
					${subtotal}
				</span>
			</div>
			<div className="mt-6 flex justify-end">
				<button
					type="button"
					onClick={() => navigate("/checkout")}
					data-testid="cart-checkout"
					className="btn-primary"
				>
					Checkout
				</button>
			</div>
		</section>
	);
}

export default Cart;
